import type { SpartacuxProB2BAnimationState } from './proB2BAnimation.model';

export const proB2BAnimationSelector = (state: SpartacuxProB2BAnimationState) =>
  state?.proB2BAnimation;

export const onboardingSelector = (state: SpartacuxProB2BAnimationState) =>
  proB2BAnimationSelector(state)?.callLater;

export const humanSupportSelectorVisible = (
  state: SpartacuxProB2BAnimationState,
) => proB2BAnimationSelector(state)?.humanSupport;

export const loyaltySpaceSelector = (state: SpartacuxProB2BAnimationState) =>
  proB2BAnimationSelector(state)?.loyaltySpace;
